import Actions from '../../odata/actions';

const actions = new Actions('userSignature', 'userSignatures');

export default actions;
